import { ts } from "src/utils/translate";

export interface MenuDisabledReason {
    disabled: boolean;
    reason: string;
}

export interface DownloadGateState {
    isPro: boolean;
    loxoneConfigPaid: boolean;
    stromlaufplanPaid: boolean;
    isLoxoneConfigDownloadAvailable: boolean;
    hasPermission: (functionName: string) => boolean;
}

const ENABLED: MenuDisabledReason = { disabled: false, reason: "" };

export function needProLicenceReason(): MenuDisabledReason {
    return {
        disabled: true,
        reason: ts("need_pro_licence", "Subscription is required to use this feature.")
    };
}

export function missingPermissionReason(): MenuDisabledReason {
    return {
        disabled: true,
        reason: ts("download_missing_permission", "You don't have permission on the project!")
    };
}

export function getLoxoneDownloadDisabledReason(state: DownloadGateState): MenuDisabledReason {
    if (!state.isPro) {
        return needProLicenceReason();
    }
    if (!state.loxoneConfigPaid) {
        return {
            disabled: true,
            reason: ts("loxone_subscription_missing", "You dont have paid loxone extension!")
        };
    }
    if (!state.isLoxoneConfigDownloadAvailable) {
        return {
            disabled: true,
            reason: ts("download_unavailable", "You have not placed any devices that would be included in the download!")
        };
    }
    if (!state.hasPermission("docu_sect.dl_lxconfig")) {
        return missingPermissionReason();
    }
    return ENABLED;
}

export function getOneWireDownloadDisabledReason(state: DownloadGateState): MenuDisabledReason {
    if (!state.isPro) {
        return needProLicenceReason();
    }
    if (!state.stromlaufplanPaid) {
        return {
            disabled: true,
            reason: ts("one_wire_subscription_missing", "You don't have paid one wire extension!")
        };
    }
    if (!state.hasPermission("docu_sect.dl_electricalplan")) {
        return missingPermissionReason();
    }
    return ENABLED;
}

export function getPdfDownloadDisabledReason(state: DownloadGateState): MenuDisabledReason {
    if (!state.isPro) {
        return needProLicenceReason();
    }
    if (!state.hasPermission("docu_sect.dl_pdf")) {
        return missingPermissionReason();
    }
    return ENABLED;
}

export function getExcelDownloadDisabledReason(state: DownloadGateState): MenuDisabledReason {
    if (!state.isPro) {
        return needProLicenceReason();
    }
    if (!state.hasPermission("bom_sect.dl_csv")) {
        return missingPermissionReason();
    }
    return ENABLED;
}
